import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import GallerySection from '../components/GallerySection';
import ReviewsSection from '../components/ReviewsSection';
import WhyWeLikeSection from '../components/WhyWeLikeSection';
import MapSection from '../components/MapSection';
import ReservationSection from '../components/ReservationSection';
import ImagesCarouselSection from '../components/ImagesCarouselSection';
import AmenitiesSection from '../components/AmenitiesSection';
import NeedtoKnowSection from '../components/NeedtoKnowSection';
import ThingsToKeepInMindSection from '../components/ThingstoKeepinMindSection';
import { useSelector } from 'react-redux';
import AuthModal from '@/components/pages/WorkspaceMap/components/Modals/AuthModal';
import { ReservationForm } from '@/components/general/Forms/NewReservationFormCopy2';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import './SpacesDetailsView.scss';

const SpacesDetailsView = props => {
  const {
    languageData,
    coordinatesForMapCenter,
    isSignInModalIsOpen,
    closeSignInModal,
    closeWarningModal,
    isWarningModalIsOpen,
    onGoogleLogin,
    openSignInModal,
    spacesDataFromBackend,
    onClickMarkers,
    spaceComments,
    backButton,
    goToWorkspaceMap,
  } = props;

  const currentSpace = spacesDataFromBackend?.[0];
  const location = useLocation();
  const modalOpen = location.pathname.endsWith('/true');
  const loggedUser = useSelector(state => state.user);
  const isAuthenticated = !!loggedUser;
  const navigate = useNavigate();

  const currentPath = location.pathname;
  const relationshipTitle =
    currentSpace?.relationship_title ||
    currentSpace?.subtype_title ||
    currentSpace?.space_title ||
    'Popnest';
  const esDescription =
    currentSpace?.description_es ||
    currentSpace?.space_description ||
    'Detalle de espacio en Popnest.';
  const enDescription =
    currentSpace?.description_en ||
    currentSpace?.space_description ||
    'Space details on Popnest.';
  const pageTitle = `${relationshipTitle} - Popnest`;

  const closeModal = () => {
    //setIsOpen(false);
    const segmentToRemove = '/true';
    let newPath = currentPath;
    if (currentPath.endsWith(segmentToRemove)) {
      newPath = currentPath.slice(0, -segmentToRemove.length);
    } else {
      console.warn(
        "La URL actual no termina en '/true'. No se realiza ningún cambio.",
      );
      return;
    }
    navigate(newPath);
  };

  const SearchBar = props => {
    const { languageData, onBack } = props;
    return (
      <FlexContainer
        className={'margt120  align-items-center padlr8 cursorPointer'}
        onClick={onBack}
      >
        <i className="fa fa-chevron-left"></i>
        <div className={'fontWhite text-12 margl10'}>
          {languageData === 'EN'
            ? 'Back to booking details'
            : 'Volver a los detalles de reserva'}
        </div>
      </FlexContainer>
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!currentSpace) return null;

  return (
    <>
      <HelmetComponent
        title={pageTitle}
        description={languageData === 'EN' ? enDescription : esDescription}
        graphTitle={pageTitle}
        graphDescription={languageData === 'EN' ? enDescription : esDescription}
      />
      <FlexContainer className="SpacesDetailsView flex-column bgGradientBlue fontWhite padlr180">
        {!modalOpen && (
          <SearchBar languageData={languageData} onBack={goToWorkspaceMap} />
        )}
        <FlexContainer
          className={`width100 justify-between ${
            modalOpen ? 'margt120' : 'margt30'
          } margb20 gap20`}
        >
          <FlexContainer className="flex-column width70 gap20">
            <GallerySection spaceData={currentSpace} />

            <FlexContainer className="width100 gap20">
              <FlexContainer className="width50">
                <WhyWeLikeSection
                  languageData={languageData}
                  spaceData={currentSpace}
                />
              </FlexContainer>

              <FlexContainer className="width50">
                <MapSection spaceData={currentSpace} />
              </FlexContainer>
            </FlexContainer>

            <FlexContainer className="width100">
              <ImagesCarouselSection spaceData={currentSpace} />
            </FlexContainer>

            <FlexContainer className="width100">
              <AmenitiesSection
                languageData={languageData}
                spaceData={currentSpace}
              />
            </FlexContainer>

            <FlexContainer className="width100">
              <NeedtoKnowSection
                languageData={languageData}
                spaceData={currentSpace}
                coordinatesForMapCenter={coordinatesForMapCenter}
                spacesDataFromBackend={spacesDataFromBackend}
                onClickMarkers={onClickMarkers}
              />
            </FlexContainer>

            <FlexContainer className="width100">
              <ThingsToKeepInMindSection
                languageData={languageData}
                spaceData={currentSpace}
              />
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className="flex-column width30 gap20">
            {!modalOpen && (
              <ReviewsSection
                languageData={languageData}
                isAuthenticated={isAuthenticated}
                openSignInModal={openSignInModal}
                spaceComments={spaceComments}
              />
            )}

            <div className="top120 pos-sticky">
              {modalOpen ? (
                <ReservationForm
                  className="bgGradientBlue border-rad8px pad20 "
                  spaceDetail={currentSpace}
                  backButton={closeModal}
                />
              ) : (
                <ReservationSection
                  spaceData={currentSpace}
                  languageData={languageData}
                  isAuthenticated={isAuthenticated}
                  openSignInModal={openSignInModal}
                />
              )}
            </div>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
      {!isAuthenticated && (
        <AuthModal
          isOpen={isSignInModalIsOpen}
          onClose={closeSignInModal}
          languageData={languageData}
          onGoogleLogin={onGoogleLogin}
        />
      )}
    </>
  );
};

export default SpacesDetailsView;
